(function(){
  'use strict';

  var selectedOrder = null;
  var selectedItems = [];
  var requestType   = null;
  var exchangeItems = [];   // array of {title, variant, img, key}
  var searchTimer   = null;

  var blockDate    = document.getElementById('re-block-date');
  if(!blockDate) return; // not logged in

  var blockForm    = document.getElementById('re-block-form');
  var expiredBox   = document.getElementById('re-expired');
  var expiredName  = document.getElementById('re-expired-name');
  var dateInput    = document.getElementById('re-date');
  var reItems      = document.getElementById('re-items');
  var typeWrap     = document.getElementById('re-type-wrap');
  var exchangeWrap = document.getElementById('re-exchange-wrap');
  var reasonWrap   = document.getElementById('re-reason-wrap');
  var noticeEl     = document.getElementById('re-notice');
  var summaryWrap  = document.getElementById('re-summary-wrap');
  var summaryBox   = document.getElementById('re-summary-content');
  var hSubject     = document.getElementById('re-h-subject');
  var hOrder       = document.getElementById('re-h-order');
  var hDate        = document.getElementById('re-h-date');
  var hType        = document.getElementById('re-h-type');
  var hItems       = document.getElementById('re-h-items');
  var hExchange    = document.getElementById('re-h-exchange');

  // Date picker limits
  var today = new Date(); today.setHours(0,0,0,0);
  dateInput.max = today.toISOString().split('T')[0];
  var minD = new Date(today); minD.setDate(minD.getDate()-60);
  dateInput.min = minD.toISOString().split('T')[0];

  // ---- STEP 1: Order click ----
  document.querySelectorAll('.aleluya-re__order').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.querySelectorAll('.aleluya-re__order').forEach(function(b){ b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var items = [];
      btn.querySelectorAll('.re-item').forEach(function(sp){
        items.push({
          id:      sp.getAttribute('data-id')      || '',
          pid:     sp.getAttribute('data-pid')     || '',
          vid:     sp.getAttribute('data-vid')     || '',
          handle:  sp.getAttribute('data-handle')  || '',
          title:   sp.getAttribute('data-title')   || '',
          variant: sp.getAttribute('data-variant') || '',
          img:     sp.getAttribute('data-img')     || '',
          qty:     parseInt(sp.getAttribute('data-qty'), 10) || 1
        });
      });
      selectedOrder = {
        id:    btn.getAttribute('data-order-id')   || '',
        name:  btn.getAttribute('data-order-name') || '',
        items: items
      };
      expiredBox.style.display = 'none';
      dateInput.value = '';
      blockDate.style.display = 'block';
      blockForm.style.display = 'none';
      resetFormState();
      setTimeout(function(){ blockDate.scrollIntoView({behavior:'smooth',block:'start'}); }, 80);
    });
  });

  // ---- STEP 2: Date / 14-day check ----
  document.getElementById('re-btn-date').addEventListener('click', function(){
    var val = dateInput.value;
    if(!val){ dateInput.focus(); return; }
    var reception = new Date(val); reception.setHours(0,0,0,0);
    var diffDays  = Math.floor((today - reception) / 86400000);
    expiredBox.style.display = 'none';
    blockForm.style.display  = 'none';
    if(diffDays > 14){
      expiredName.textContent = selectedOrder ? selectedOrder.name : '';
      expiredBox.style.display = 'block';
    } else {
      hOrder.value   = selectedOrder ? selectedOrder.name : '';
      hDate.value    = val;
      hSubject.value = 'RETURN/EXCHANGE REQUEST \u2014 ' + (selectedOrder ? selectedOrder.name : '');
      buildItems(selectedOrder ? selectedOrder.items : []);
      resetFormState();
      blockForm.style.display = 'block';
      setTimeout(function(){ blockForm.scrollIntoView({behavior:'smooth',block:'start'}); }, 80);
    }
  });

  // ---- STEP 3a: Render item checkboxes ----
  function buildItems(items){
    reItems.innerHTML = '';
    selectedItems = [];
    if(!items || !items.length){
      reItems.innerHTML = '<p class="aleluya-re__empty">No items found for this order.</p>';
      return;
    }
    items.forEach(function(item){
      var label = document.createElement('label');
      label.className = 'aleluya-re__item';
      var imgHtml = item.img
        ? '<img src="'+escAttr(item.img)+'" alt="'+escHtml(item.title)+'" class="aleluya-re__item-img" loading="lazy">'
        : '<div class="aleluya-re__item-img"></div>';
      var varLine = (item.variant && item.variant !== 'Default Title') ? escHtml(item.variant)+' &mdash; ' : '';
      label.innerHTML =
        '<input type="checkbox" class="aleluya-re__item-cb">' +
        imgHtml +
        '<div class="aleluya-re__item-info">' +
          '<span class="aleluya-re__item-title">'+escHtml(item.title)+'</span>' +
          '<span class="aleluya-re__item-variant">'+varLine+'Qty: '+item.qty+'</span>' +
        '</div>';
      var cb = label.querySelector('input');
      cb.addEventListener('change', function(){
        if(cb.checked){ label.classList.add('is-checked'); selectedItems.push(item); }
        else           { label.classList.remove('is-checked'); selectedItems = selectedItems.filter(function(i){ return i.id !== item.id; }); }
        onItemChange();
      });
      reItems.appendChild(label);
    });
  }

  function onItemChange(){
    typeWrap.style.display = selectedItems.length ? 'block' : 'none';
    if(!selectedItems.length){ hideExchange(); hideSummaryNotice(); }
  }

  // ---- STEP 3b: Type selection ----
  document.querySelectorAll('.aleluya-re__type-btn').forEach(function(btn){
    btn.addEventListener('click', function(){ selectType(btn.getAttribute('data-type')); });
  });

  function selectType(type){
    requestType = type; hType.value = type;
    document.querySelectorAll('.aleluya-re__type-btn').forEach(function(b){ b.classList.remove('is-active'); });
    document.querySelector('.aleluya-re__type-btn[data-type="'+type+'"]').classList.add('is-active');
    if(type === 'exchange'){
      exchangeWrap.style.display = 'block';
      document.getElementById('re-reason-num').textContent  = '06';
      document.getElementById('re-summary-num').textContent = '07';
      exchangeItems = [];
      updateExchangeList();
      hideSummaryNotice();
    } else {
      hideExchange();
      document.getElementById('re-reason-num').textContent  = '05';
      document.getElementById('re-summary-num').textContent = '06';
      showReasonNotice(); buildSummary();
    }
  }

  // ---- Exchange item list (multi-item with photos) ----
  function addExchangeItem(title, variant, img){
    var key = title + '||' + (variant || '');
    if(exchangeItems.some(function(e){ return e.key === key; })) return;
    exchangeItems.push({title:title, variant:variant||'', img:img||'', key:key});
    updateExchangeList();
    updateHExchange();
    showReasonNotice(); buildSummary();
  }

  function removeExchangeItem(key){
    exchangeItems = exchangeItems.filter(function(e){ return e.key !== key; });
    updateExchangeList();
    updateHExchange();
    if(!exchangeItems.length){ hideSummaryNotice(); } else { buildSummary(); }
  }

  function updateExchangeList(){
    var list = document.getElementById('re-exchange-list');
    var wrap = document.getElementById('re-exchange-list-wrap');
    if(!list || !wrap) return;
    if(!exchangeItems.length){ wrap.style.display='none'; list.innerHTML=''; return; }
    wrap.style.display = 'block';
    list.innerHTML = '';
    exchangeItems.forEach(function(item){
      var div = document.createElement('div');
      div.className = 're-exitem';
      var imgHtml = item.img
        ? '<img src="'+escAttr(item.img)+'" alt="'+escHtml(item.title)+'" class="re-exitem__img" loading="lazy">'
        : '<div class="re-exitem__img re-exitem__img--ph"></div>';
      var nameHtml = '<strong class="re-exitem__title">'+escHtml(item.title)+'</strong>'
        + (item.variant ? '<span class="re-exitem__variant"> \u2014 '+escHtml(item.variant)+'</span>' : '');
      div.innerHTML = imgHtml
        + '<span class="re-exitem__info">'+nameHtml+'</span>'
        + '<button type="button" class="re-exitem__rm" aria-label="Remove">\u00d7</button>';
      (function(k){ div.querySelector('.re-exitem__rm').addEventListener('click', function(){ removeExchangeItem(k); }); })(item.key);
      list.appendChild(div);
    });
  }

  function updateHExchange(){
    hExchange.value = exchangeItems.map(function(e){ return e.title+(e.variant?' \u2014 '+e.variant:''); }).join(' | ');
  }

  // ---- hideExchange: full reset of exchange section ----
  function hideExchange(){
    exchangeWrap.style.display = 'none'; exchangeItems = []; hExchange.value = '';
    var sw = document.getElementById('re-sizechange-wrap');
    if(sw){ sw.classList.remove('is-open'); sw.setAttribute('aria-hidden','true'); }
    var bc = document.getElementById('btn-change-size');
    if(bc){ bc.classList.remove('is-active'); }
    var si = document.getElementById('re-sizechange-items');
    if(si){ si.innerHTML = ''; }
    document.getElementById('re-search-wrap').style.display = 'none';
    document.getElementById('re-search').value = '';
    document.getElementById('re-search-results').innerHTML = '';
    document.getElementById('re-selected-product').style.display = 'none';
    var dv = document.getElementById('re-diff-variants');
    if(dv){ dv.innerHTML=''; dv.style.display='none'; }
    var dl = document.getElementById('re-diff-size-label');
    if(dl){ dl.style.display='none'; }
    var ew = document.getElementById('re-exchange-list-wrap');
    if(ew){ ew.style.display='none'; }
    var el = document.getElementById('re-exchange-list');
    if(el){ el.innerHTML=''; }
  }

  // ---- CHANGE SIZE: same item, different size (only in-stock) ----
  var btnChangeSize   = document.getElementById('btn-change-size');
  var sizeChangeWrap  = document.getElementById('re-sizechange-wrap');

  function openSizePanel(){
    buildSizeChangePanel();
    sizeChangeWrap.classList.add('is-open');
    sizeChangeWrap.setAttribute('aria-hidden','false');
    btnChangeSize.classList.add('is-active');
  }
  function closeSizePanel(){
    sizeChangeWrap.classList.remove('is-open');
    sizeChangeWrap.setAttribute('aria-hidden','true');
    btnChangeSize.classList.remove('is-active');
  }

  btnChangeSize.addEventListener('click', function(){
    if(sizeChangeWrap.classList.contains('is-open')){ closeSizePanel(); return; }
    openSizePanel();
  });

  document.getElementById('btn-sizechange-close').addEventListener('click', closeSizePanel);

  function buildSizeChangePanel(){
    var container = document.getElementById('re-sizechange-items');
    container.innerHTML = '';
    if(!selectedItems.length){
      container.innerHTML = '<p class="aleluya-re__size-note">Select an item first.</p>';
      return;
    }
    selectedItems.forEach(function(item){
      var row = document.createElement('div');
      row.className = 're-sizeitem';
      var imgHtml = item.img
        ? '<img src="'+escAttr(item.img)+'" alt="'+escHtml(item.title)+'" class="re-sizeitem__img" loading="lazy">'
        : '<div class="re-sizeitem__img"></div>';
      var varLine = (item.variant && item.variant !== 'Default Title') ? escHtml(item.variant) : '';
      row.innerHTML = imgHtml +
        '<div class="re-sizeitem__info">' +
          '<strong class="re-sizeitem__title">'+escHtml(item.title)+'</strong>' +
          (varLine ? '<span class="re-sizeitem__variant">'+varLine+'</span>' : '') +
          '<div class="re-sizeitem__sizes"><span class="aleluya-re__size-note">Loading sizes...</span></div>' +
        '</div>';
      container.appendChild(row);
      loadSizesForItem(row.querySelector('.re-sizeitem__sizes'), item);
    });
  }

  function loadSizesForItem(sizesEl, item){
    if(!item.handle){
      sizesEl.innerHTML = '<span class="aleluya-re__size-note">No size options found.</span>';
      return;
    }
    fetch('/products/'+encodeURIComponent(item.handle)+'.js')
      .then(function(r){ return r.json(); })
      .then(function(product){
        sizesEl.innerHTML = '';
        var variants = product.variants || [];
        var imgUrl = (product.images && product.images[0]) ? product.images[0] : (product.featured_image || '');
        if(variants.length <= 1 && variants[0] && variants[0].title === 'Default Title'){
          sizesEl.innerHTML = '<span class="aleluya-re__size-note">This item has no size options.</span>';
          return;
        }
        var anyAvailable = false;
        variants.forEach(function(v){
          var isCur  = String(v.id) === String(item.vid);
          var isAvail = !!v.available;
          if(isAvail && !isCur) anyAvailable = true;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'aleluya-re__variant-btn'
            + (isCur ? ' is-current' : '')
            + (isAvail ? '' : ' is-soldout');
          if(isCur){
            btn.innerHTML = escHtml(v.title) + '<span class="aleluya-re__variant-tag">CURRENT</span>';
          } else if(!isAvail){
            btn.innerHTML = escHtml(v.title) + '<span class="aleluya-re__variant-tag">SOLD OUT</span>';
          } else {
            btn.textContent = v.title;
          }
          if(isCur || !isAvail){ btn.disabled = true; }
          else {
            btn.addEventListener('click', function(){
              var key = product.title + '||' + v.title;
              var already = exchangeItems.some(function(e){ return e.key === key; });
              if(already){ removeExchangeItem(key); btn.classList.remove('is-active'); }
              else { btn.classList.add('is-active'); addExchangeItem(product.title, v.title, imgUrl); }
            });
          }
          sizesEl.appendChild(btn);
        });
        if(!anyAvailable){
          var note = document.createElement('div');
          note.className = 'aleluya-re__size-note aleluya-re__size-note--error';
          note.textContent = 'No sizes currently in stock for this item.';
          sizesEl.appendChild(note);
        }
      })
      .catch(function(){
        sizesEl.innerHTML = '<span class="aleluya-re__size-note aleluya-re__size-note--error">Could not load sizes. Please try again.</span>';
      });
  }

  // ---- Different product search ----
  document.getElementById('btn-diff-product').addEventListener('click', function(){
    document.getElementById('re-search-wrap').style.display = 'block';
    document.getElementById('re-search').focus();
  });

  document.getElementById('re-search').addEventListener('input', function(){
    clearTimeout(searchTimer);
    var q = this.value.trim();
    document.getElementById('re-search-results').innerHTML = '';
    document.getElementById('re-selected-product').style.display = 'none';
    if(q.length < 2) return;
    searchTimer = setTimeout(function(){ doSearch(q); }, 320);
  });

  function doSearch(q){
    var res = document.getElementById('re-search-results');
    res.innerHTML = '<div style="padding:12px 16px;font-size:13px;color:#aaa">Searching...</div>';
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
      .then(function(r){ return r.json(); })
      .then(function(d){ renderResults((d.resources&&d.resources.results&&d.resources.results.products)||[], res); })
      .catch(function(){ res.innerHTML='<div style="padding:12px 16px;font-size:13px;color:#c00028">Search error. Try again.</div>'; });
  }

  function renderResults(products, container){
    if(!products.length){ container.innerHTML='<div style="padding:12px 16px;font-size:13px;color:#888">No products found.</div>'; return; }
    container.innerHTML='';
    products.forEach(function(p){
      var div=document.createElement('div'); div.className='aleluya-re__result';
      var imgUrl=(typeof p.image==='string'?p.image:'') || (p.featured_image&&p.featured_image.url) || '';
      div.innerHTML=(imgUrl?'<img src="'+escAttr(imgUrl)+'" alt="'+escHtml(p.title)+'" loading="lazy">':'<div style="width:48px;height:48px;background:#f0f0f0;flex-shrink:0"></div>')
        +'<div><span class="aleluya-re__result-title">'+escHtml(p.title)+'</span><span class="aleluya-re__result-hint">Tap to select</span></div>';
      div.addEventListener('click', function(){ selectDiffProduct(p); });
      container.appendChild(div);
    });
  }

  function selectDiffProduct(p){
    document.getElementById('re-search').value = p.title;
    document.getElementById('re-search-results').innerHTML = '';
    var selBox = document.getElementById('re-selected-product');
    selBox.style.display = 'flex';
    selBox.innerHTML = '<span>\u2713 <strong>'+escHtml(p.title)+'</strong></span>'
      +'<button type="button" class="aleluya-re__selected-clear" id="btn-clear-sel">Change</button>';
    document.getElementById('btn-clear-sel').addEventListener('click', function(){
      selBox.style.display = 'none';
      document.getElementById('re-search').value = '';
      var dv=document.getElementById('re-diff-variants'); if(dv){ dv.innerHTML=''; dv.style.display='none'; }
      var dl=document.getElementById('re-diff-size-label'); if(dl){ dl.style.display='none'; }
    });
    var imgUrl=(p.image&&p.image.url)||(p.featured_image&&p.featured_image.url)||'';
    loadVariantsForDiffProduct(p.handle||'', p.title, imgUrl);
  }

  function loadVariantsForDiffProduct(handle, productTitle, productImg){
    var dv = document.getElementById('re-diff-variants');
    var dl = document.getElementById('re-diff-size-label');
    dv.innerHTML = '<span style="font-size:13px;color:#aaa">Loading options...</span>';
    dv.style.display = 'flex'; dl.style.display = 'none';
    if(!handle){
      dv.style.display = 'none';
      addExchangeItem(productTitle, '', productImg);
      resetDiffSearch(); return;
    }
    fetch('/products/'+encodeURIComponent(handle)+'.js')
      .then(function(r){ return r.json(); })
      .then(function(product){
        var variants = product.variants || [];
        var imgUrl = (product.images && product.images[0]) ? product.images[0] : (product.featured_image || productImg);
        if(variants.length <= 1 && variants[0] && variants[0].title === 'Default Title'){
          dv.style.display='none'; dl.style.display='none';
          addExchangeItem(productTitle, '', imgUrl); resetDiffSearch(); return;
        }
        dv.innerHTML=''; dl.style.display='block'; dv.style.display='flex';
        variants.forEach(function(v){
          var btn = document.createElement('button');
          btn.type='button';
          btn.className='aleluya-re__variant-btn' + (v.available ? '' : ' is-soldout');
          btn.textContent=v.title;
          if(!v.available){ btn.disabled = true; }
          else {
            btn.addEventListener('click', function(){
              var key = productTitle+'||'+v.title;
              if(!exchangeItems.some(function(e){ return e.key===key; })){
                addExchangeItem(productTitle, v.title, imgUrl);
                resetDiffSearch();
              }
            });
          }
          dv.appendChild(btn);
        });
      })
      .catch(function(){
        dv.style.display='none'; dl.style.display='none';
        addExchangeItem(productTitle, '', productImg); resetDiffSearch();
      });
  }

  function resetDiffSearch(){
    document.getElementById('re-search').value='';
    document.getElementById('re-search-results').innerHTML='';
    document.getElementById('re-selected-product').style.display='none';
    var dv=document.getElementById('re-diff-variants'); if(dv){ dv.innerHTML=''; dv.style.display='none'; }
    var dl=document.getElementById('re-diff-size-label'); if(dl){ dl.style.display='none'; }
  }

  function showReasonNotice(){ reasonWrap.style.display='block'; noticeEl.style.display='block'; }

  function buildSummary(){
    if(!selectedOrder||!selectedItems.length||!requestType) return;
    if(requestType==='exchange'&&!exchangeItems.length) return;
    var itemsList=selectedItems.map(function(i){ return i.title+(i.variant&&i.variant!=='Default Title'?' \u2014 '+i.variant:''); }).join(', ');
    hItems.value=itemsList;
    var exLine='';
    if(requestType==='exchange'&&exchangeItems.length){
      exLine='<span class="re-label">EXCHANGE FOR</span>';
      exchangeItems.forEach(function(e){
        var imgPart=e.img?'<img src="'+escAttr(e.img)+'" style="width:32px;height:32px;object-fit:cover;vertical-align:middle;margin-right:8px;border:1px solid #e0e0e0"> ':'';
        exLine+='<span class="re-value" style="display:flex;align-items:center;margin-bottom:4px">'+imgPart+escHtml(e.title)+(e.variant?' \u2014 '+escHtml(e.variant):'')+'</span>';
      });
    }
    summaryBox.innerHTML='<span class="re-label">ORDER</span><span class="re-value">'+escHtml(selectedOrder.name)+'</span>'
      +'<span class="re-label">REQUEST TYPE</span><span class="re-value">'+(requestType==='return'?'Return &amp; Refund':'Exchange')+'</span>'
      +'<span class="re-label">ITEM(S) TO RETURN</span><span class="re-value">'+escHtml(itemsList)+'</span>'+exLine;
    summaryWrap.style.display='block';
  }

  function hideSummaryNotice(){ summaryWrap.style.display='none'; noticeEl.style.display='none'; reasonWrap.style.display='none'; }

  function resetFormState(){
    selectedItems=[]; requestType=null; exchangeItems=[]; hExchange.value='';
    typeWrap.style.display='none'; hideExchange(); hideSummaryNotice();
    document.querySelectorAll('.aleluya-re__type-btn').forEach(function(b){ b.classList.remove('is-active'); });
    hType.value=''; hItems.value='';
  }

  function escHtml(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function escAttr(s){ return String(s||'').replace(/"/g,'&quot;'); }

})();
